import { Box, Group, Flex, Burger, Badge, Text } from '@mantine/core';
import { FaFileAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import { ThemeToggle } from '../ui/ThemeToggle';
import { NotificationIcon } from '../features/notifications/NotificationIcon';
import { DevTools } from '../dev-tools/DevTools';

export interface HeaderProps {
  /** Whether the user is authenticated */
  isAuthenticated?: boolean;
  /** Whether to show the burger menu */
  showBurger?: boolean;
  /** Handler for burger click */
  onBurgerClick?: () => void;
}

export function Header({ isAuthenticated = false, showBurger = false, onBurgerClick }: HeaderProps) {
  return (
    <Box
      component="header"
      w="100%"
      py="md"
      px="xl"
      style={{ borderBottom: '1px solid var(--mantine-color-default-border)' }}
    >
      <Flex align="center" justify="space-between" h="100%">
        <Group gap="xs" wrap="nowrap">
          {showBurger && onBurgerClick && <Burger hiddenFrom="md" size="sm" onClick={onBurgerClick} />}
          <Link to={isAuthenticated ? '/' : '/login'} style={{ textDecoration: 'none', color: 'inherit' }}>
            <Group gap="xs" wrap="nowrap">
              <FaFileAlt size={isAuthenticated ? 24 : 20} color="var(--mantine-color-primary-6)" />
              <Text size="xl" fw={700} style={{ whiteSpace: 'nowrap' }}>
                EPD Validator
              </Text>
              <Badge color="yellow" ml="xs" variant="filled">
                Early Preview
              </Badge>
            </Group>
          </Link>
        </Group>

        <Group wrap="nowrap">
          <ThemeToggle />
          {isAuthenticated && <NotificationIcon />}
          {isAuthenticated && process.env.NODE_ENV === 'development' && <DevTools />}
        </Group>
      </Flex>
    </Box>
  );
}
